module.exports = __webpack_public_path__ + "img/business.a245769d.png";